import { capitalizeFirstLetter } from "@/utilities/stringFormatters";
import { Tooltip } from "antd";
import LinkOrSpan from "../links/LinkOrSpan/LinkOrSpan";
import { statProperties, Status } from "../StatusTag/StatusTag";

export default function StatusIcon({ status, to }: { status: Status; to?: string }) {
  const properties = statProperties[status];
  return (
    <LinkOrSpan
      to={to}
      style={{ color: properties.color }}
    >
      <Tooltip title={capitalizeFirstLetter(properties.textSingular)}>{properties.icon}</Tooltip>
    </LinkOrSpan>
  );
}
